// 1二级tab，定制头部
// 2使用项目自己的头部
// 3隐藏项目其中的头部
// 4快应用使用的头
export var HeaderTypeDic;
(function (HeaderTypeDic) {
    HeaderTypeDic["TabHeader"] = "1";
    HeaderTypeDic["Header"] = "2";
    HeaderTypeDic["HideHeader"] = "3";
    HeaderTypeDic["QuickAppHeader"] = "4";
})(HeaderTypeDic || (HeaderTypeDic = {}));
// 实现支付类型对象
export const HeaderType = {
    ENUM: {
        [HeaderTypeDic.TabHeader]: '1二级tab，定制头部',
        [HeaderTypeDic.Header]: '2使用项目自己的头部',
        [HeaderTypeDic.HideHeader]: '3隐藏项目其中的头部',
        [HeaderTypeDic.QuickAppHeader]: '4快应用使用的头'
    },
    TabHeader: HeaderTypeDic.TabHeader,
    Header: HeaderTypeDic.Header,
    HideHeader: HeaderTypeDic.HideHeader,
    QuickAppHeader: HeaderTypeDic.QuickAppHeader
};
